import { TemplateCard } from './TemplateCard';
export function Item(props) {
    const { composer, onClick } = props;
    const { id, metadata, category, locked } = composer;
    const { name } = metadata[0];
    const categoryTitle = (category === null || category === void 0 ? void 0 : category.metadata[0].title) || '';
    return (<TemplateCard onClick={() => onClick(id)} composerId={id} title={name} category={categoryTitle} locked={locked}/>);
}
